import { addLeadingSlash } from "@frend-digital/utils";

export const getProductLink = (
	parentHref: string | undefined,
	product: { uri: string; canonicalUri?: string },
) => {
	if (product.canonicalUri) {
		return addLeadingSlash(product.canonicalUri);
	}

	return parentHref
		? `${addLeadingSlash(parentHref)}${addLeadingSlash(product.uri)}`
		: `/${product.uri}`;
};
